<div class="container">
    <div class="header-container">
        <div class="header-container">
            <div class="loading" *ngIf="loading">
                <div class="loader"></div>
            </div>
        </div>
    </div>
    <div *ngIf="!loading">
        <div class="content" style="margin-bottom:64px;">

            <div class="row">
                <div class="col-md-12">
                    <h4>Cover Photo</h4>
                </div>
            </div>
            <div class="row margin-top-8">
                <div class="col-md-4 label" [ngClass]="{'red': !trail.coverPhoto || trail.coverPhoto.length===0}">Upload
                    a
                    primary cover photo for this trail:
                </div>
                <div class="col-md-4">
                    <div class="header-image">
                        <div style="position: relative;">
                            <img class="coverphoto"
                                 [src]="trail.coverPhoto === null ? placeholderImage : trail.coverPhoto"
                                 style="max-width:500px"/>
                            <div class="margin-top-8">
                                <button pButton type="button" icon="fa fa-picture-o" class="p-button accentsolid"
                                        label="Upload Cover Photo" (click)="fileUpload.click()"></button>
                                <input #fileUpload type="file" style="display: none" (change)="myUploader($event)">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row margin-top-8">
                <div class="col-md-4 label"></div>
                <div class="col-md-4"><i>***For the best results, use a landscape photo.</i></div>
            </div>

            <div class="row margin-top-16">
                <div class="col-md-12">
                    <h4>Trail Information</h4>
                </div>
            </div>
            <div class="row margin-top-8">
                <div class="col-md-4 label" [ngClass]="{'red': !trail.trailName || trail.trailName.length===0}">Trail
                    Name:
                </div>
                <div class="col-md-8">
                    <div class="p-inputgroup">
                        <input type="text" pInputText placeholder="Enter the trail name" [(ngModel)]="trail.trailName"/>
                    </div>
                </div>
            </div>

            <div class="row margin-top-8">
                <div class="col-md-4 label"
                     [ngClass]="{'red': !trail.trailDescription || trail.trailDescription.length===0}">
                    Trail Description:
                </div>
                <div class="col-md-8">
                    <div class="p-inputgroup">
            <textarea type="text" pInputTextarea [autoResize]="true" class="p-fluid"
                      placeholder="Enter a description for this trail" rows="5"
                      [(ngModel)]="trail.trailDescription"></textarea>
                    </div>
                </div>
            </div>

            <div class="row margin-top-8">
                <div class="col-md-4 label" [ngClass]="{'red': !trail.fee || trail.fee.length===0}">Trail Fee:</div>
                <div class="col-md-4">
                    <div class="p-inputgroup">
                        <input type="text" pInputText placeholder="e.g. R50 for a day or R600 for an annual pass"
                               [(ngModel)]="trail.fee"/>
                    </div>
                </div>
            </div>

            <div class="row margin-top-8">
                <div class="col-md-4 label" [ngClass]="{'red': !trail.address || trail.address.length===0}">Physical
                    Address:
                </div>
                <div class="col-md-8">
                    <div class="p-inputgroup">
                        <input type="text" pInputText placeholder="Enter the street address for this trail"
                               [(ngModel)]="trail.address"/>
                    </div>
                </div>
            </div>

            <div class="row margin-top-8">
                <div class="col-md-4 label">Website address:</div>
                <div class=" col-md-4">
                    <div class="p-inputgroup">
                        <input type="text" pInputText placeholder="If you have a website, enter the address..."
                               [(ngModel)]="trail.webAddress"/>
                    </div>
                </div>
            </div>

            <div class="row margin-top-8">
                <div class="col-md-4 label">Facilities:</div>
                <div class="col-md-8">
                    <div class="p-inputgroup">
                        <p-chips [(ngModel)]="trail.facilities" placeholder="Enter any facilities"></p-chips>
                    </div>
                </div>
            </div>

            <div class="row margin-top-8" [ngClass]="{'red': !trail.terrainType || trail.terrainType.length===0}">
                <div class="col-md-4 label">Terrain Type:</div>
                <div class="col-md-8">
                    <div class="p-inputgroup">
                        <p-chips [(ngModel)]="trail.terrainType"
                                 placeholder="Enter the types of terrain found on this trail e.g. rocky, muddy, loose sand etc"></p-chips>
                    </div>
                </div>
            </div>
            <div class="row margin-top-8" [ngClass]="{'red': !trail.trailCondition || trail.trailCondition.length===0}">
                <div class="col-md-4 label">Trail Condition:</div>
                <div class="col-md-4">
                    <div class="p-inputgroup">
                        <p-dropdown [options]="conditions" [(ngModel)]="trail.trailCondition"
                                    placeholder="Select the condition of this trail">
                            <ng-template let-trailCondition pTemplate="trailCondition">
                                <span style="margin-left:.25em">{{trailCondition.label}}</span>
                            </ng-template>
                        </p-dropdown>
                    </div>
                </div>
            </div>
            <div class="row margin-top-8" [ngClass]="{'red': !trail.trailStatus || trail.trailStatus.length===0}">
                <div class="col-md-4 label">Status:</div>
                <div class="col-md-4">
                    <div class="p-inputgroup">
                        <p-dropdown [options]="status" [(ngModel)]="trail.trailStatus"
                                    placeholder="Select the status of this trail">
                            <ng-template let-status pTemplate="status">
                                <span style="margin-left:.25em">{{status.label}}</span>
                            </ng-template>
                        </p-dropdown>
                    </div>
                </div>
            </div>


            <div class="row margin-top-16">
                <div class="col-md-12">
                    <h4>Contact Information</h4>
                </div>
            </div>
            <div class="row margin-top-8">
                <div class="col-md-4 label">Email Address:
                </div>
                <div class="col-md-4">
                    <div class="p-inputgroup">
                        <input type="text" pInputText placeholder="Enter an email address if you have one"
                               [(ngModel)]="trail.emailAddress"/>
                    </div>
                </div>
            </div>
            <div class="row margin-top-8">
                <div class="col-md-4 label">Phone Number:
                </div>
                <div class="col-md-4">
                    <div class="p-inputgroup">
                        <input type="text" pInputText placeholder="Enter a phone number if you have one"
                               [(ngModel)]="trail.phoneNumber"/>
                    </div>
                </div>
            </div>
            <div class="row margin-top-8">
                <div class="col-md-4 label">Alternate Phone Number:
                </div>
                <div class="col-md-4">
                    <div class="p-inputgroup">
                        <input type="text" pInputText placeholder="Any alternate numbers, enter them here..."
                               [(ngModel)]="trail.alternateNumber"/>
                    </div>
                </div>
            </div>
            <div class="row margin-top-8">
                <div class="col-md-4 label">Emergency Number:
                </div>
                <div class="col-md-4">
                    <div class="p-inputgroup">
                        <input type="text" pInputText placeholder="Enter an emergency number"
                               [(ngModel)]="trail.emergencyNumber"/>
                    </div>
                </div>
            </div>

            <div class="row margin-top-16">
                <div class="col-md-12">
                    <h4>Trading Hours</h4>
                </div>
            </div>
            <div *ngFor="let dayOfWeek of dayOfWeeks;let i = index;">
                <div class="row margin-top-8">
                    <div class="col-md-4 label">{{i === 0 ? "Set the opening hours for this trail:" : ""}}</div>
                    <div class="col-md-2 label">{{getDayOfWeek(dayOfWeek.dayOfTheWeek)}}
                    </div>
                    <div class="col-md-2">
                        <div class="p-inputgroup">
                            <p-inputSwitch [(ngModel)]="dayOfWeek.open" binary="true"
                                           [ngModelOptions]="{standalone: true}">
                            </p-inputSwitch>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="p-inputgroup">
                            <span class="label" style="width: auto;margin-right: 16px;">From:</span>
                            <p-dropdown [disabled]="!dayOfWeek.open" [options]="workingHours"
                                        [(ngModel)]="dayOfWeek.openTime">
                            </p-dropdown>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="p-inputgroup">
                            <span class="label" style="width: auto;margin-right: 16px;">To:</span>
                            <p-dropdown [disabled]="!dayOfWeek.open" [options]="workingHours"
                                        [(ngModel)]="dayOfWeek.closeTime">
                            </p-dropdown>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row margin-top-32">
                <div class="col-md-12">
                    <h4>Additional Images & Media</h4>
                </div>
            </div>
            <div class="row margin-top-8">
                <div class="col-md-12 label">You can add more awesome pictures of the trails, they will all be displayed
                    within
                    the app in the gallery for the trail.
                </div>
            </div>
            <div class="row margin-top-8">
                <div class="col-md-4 label"></div>
                <div class="col-md-8">
                    <div class="gallery">
                        <div *ngFor="let media of trail.trailsMedia;let i = index;">
                            <div style="position: relative;">
                                <img [src]="media.mediaURL">
                                <span class="fa fa-times remove-image" (click)="removeImage(i)"></span>
                            </div>
                        </div>
                    </div>
                    <button pButton type="button" icon="fa fa-picture-o" class="p-button accentsolid"
                            label="Add Other Photos"
                            (click)="imagesUpload.click()"></button>
                    <input #imagesUpload type="file" style="display: none" multiple accept="image/*;capture=camera"
                           (change)="myImagesUploader($event)">
                </div>
            </div>

            <div class="row margin-top-32">
                <div class="col-md-12">
                    <h4>GPX Routes</h4>
                </div>
            </div>
            <div class="row margin-top-8">
                <div class="col-md-12 label">Any routes you add with GPX files will be viewable on this map. The routes
                    will be
                    coded with the colour you choose for the route.
                </div>
            </div>
            <div class="row margin-top-8">
                <div class="col-md-4 label"></div>
                <div class="col-md-8">
                    <div class="map-container" style="overflow: hidden;">
                        <div id="map"></div>
                    </div>
                </div>
            </div>

            <div class="row margin-top-32">
                <div class="col-md-12">
                    <h4>Routes</h4>
                </div>
                <div pTooltip="Add a route to the trail"
                     style="margin-right:24px;position: absolute; right: 0px;" tooltipPosition="left"
                     class="fa fa-plus font-button pull-right"
                     (click)="addRoute()"></div>
            </div>

            <div class="row margin-top-8">
                <div class="col-md-12 label">If the trail contains various routes for e.g. a blue loop, green loop,
                    intermediate, advanced...call it what you want, here you can add the various routes and upload GPX
                    files etc.
                </div>
            </div>
            <div class="route-container">
                <div *ngFor="let route of trail.trailRoutes;let i = index;" class="route">
                    <div>
                        <div class="row margin-top-8">
                            <div class="col-md-6 label"
                                 [ngClass]="{'red': !route.routeName || route.routeName.length===0}">Route
                                Name:
                            </div>
                            <div class="col-md-6">
                                <div class="p-inputgroup">
                                    <input type="text" pInputText
                                           placeholder="A name for the route e.g. blue loop, black loop, beginner route"
                                           [(ngModel)]="route.routeName"/>
                                </div>
                            </div>
                        </div>

                        <div class="row margin-top-8">
                            <div class="col-md-6 label">
                                Route Description:
                            </div>
                            <div class="col-md-6">
                                <div class="p-inputgroup">
                  <textarea type="text" pInputTextarea [autoResize]="true" class="p-fluid"
                            placeholder="Enter a description for this route (Optional)" rows="2"
                            [(ngModel)]="route.routeDescription"></textarea>
                                </div>
                            </div>
                        </div>

                        <div class="row margin-top-8"
                             [ngClass]="{'red': !route.skillLevel || route.skillLevel.length===0}">
                            <div class="col-md-6 label">Skill Level:</div>
                            <div class="col-md-6">
                                <div class="p-inputgroup">
                                    <p-dropdown [options]="skillLevels" [(ngModel)]="route.skillLevel"
                                                placeholder="Select the skill level of the rider needed to ride this route">
                                        <ng-template let-skillLevel pTemplate="skillLevel">
                                            <span style="margin-left:.25em">{{skillLevel.value}}</span>
                                        </ng-template>
                                    </p-dropdown>
                                </div>
                            </div>
                        </div>

                        <div class="row margin-top-8">
                            <div class="col-md-6 label">Add a GPX file for this route</div>
                            <div class="col-md-6">
                                <button pButton type="button" icon="fa fa-map-marker"
                                        class="p-button-raised accentsolid full-width"
                                        label="Upload GPX Route File" (click)="fileUpload.click()"></button>
                                <input #fileUpload type="file" style="display: none" (change)="uploadGPX($event, route)"
                                       accept=".gpx">
                            </div>
                        </div>

                        <div class="row margin-top-8" *ngIf="route.gpxurl">
                            <div class="col-md-6 label"></div>
                            <div class="col-md-6">
                                <button pButton type="button" icon="fa fa-trash"
                                        class="p-button-raised full-width solid"
                                        label="Remove GPX" (click)="removeGPX(route)"></button>
                            </div>
                        </div>

                        <div class="row margin-top-8" *ngIf="route.gpxurl">
                            <div class="col-md-6 label">Route Color:
                            </div>
                            <div class="col-md-6">
                                <div class="p-inputgroup">
                                    <!--                  todo (dcorbett) removed: [(colorPicker)]="route.routeColor"   (colorPickerChange)="updateMap()"-->
                                    <input pInputText [(ngModel)]="route.routeColor"
                                           [style.color]="route.routeColor"/>
                                </div>
                            </div>
                        </div>
                        <div class="row margin-top-8">
                            <div class="col-md-6 label"
                                 [ngClass]="{'red': !route.distance || route.distance.length===0}">Route
                                Distance
                                (Km):
                            </div>
                            <div class="col-md-6">
                                <div class="p-inputgroup">
                                    <input type="number" pInputText
                                           placeholder="Enter the distance for the route in Km's"
                                           [(ngModel)]="route.distance"/>
                                </div>
                            </div>
                        </div>
                        <div class="row margin-top-8">
                            <div class="col-md-6 label">Total Ascent Elevation (meters):
                            </div>
                            <div class="col-md-6">
                                <div class="p-inputgroup">
                                    <input type="number" pInputText
                                           placeholder="Enter the total ascending elevation (Optional)"
                                           [(ngModel)]="route.ascent"/>
                                </div>
                            </div>
                        </div>
                        <div class="row margin-top-8">
                            <div class="col-md-6 label">Total Descent Elevation (meters):
                            </div>
                            <div class="col-md-6">
                                <div class="p-inputgroup">
                                    <input type="number" pInputText
                                           placeholder="Enter the total decending elevation (Optional)"
                                           [(ngModel)]="route.decent"/>
                                </div>
                            </div>
                        </div>
                        <div class="row margin-top-16">
                            <div class="col-md-6"></div>
                            <div class="col-md-6">
                                <button pButton type="button"
                                        class="p-button-raised solid full-width" label="Remove Route"
                                        (click)="removeRoute(i)"></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row margin-top-16">
                <div class="col-md-8"></div>
                <div class="col-md-2">
                    <button pButton type="button" class="p-button-raised full-width" *ngIf="trail.uniqueID"
                            label="Delete Trail" (click)="deleteTrail()" [disabled]="deleting || loading"></button>
                </div>
                <div class="col-md-2">
                    <button pButton type="button" class="p-button-raised approve full-width"
                            label="{{saving ? 'Please Wait' : 'Save Changes'}}" (click)="saveTrail()"
                            [disabled]="saving || loading || !valid()"></button>
                </div>
            </div>


        </div>
    </div>
</div>
<p-confirmDialog></p-confirmDialog>
<p-toast position="bottom-right" styleClass="hubtiger-toast"></p-toast>
